// extracted by mini-css-extract-plugin
export var arrow = "_2u-6";
export var changeItem = "_2u-3";
export var changesHeader = "_2u-1";
export var changesList = "_2u-2";
export var container = "_2u-0";
export var pathLabel = "_2u-4";
export var value = "_2u-7";
export var valuesContainer = "_2u-5";